<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="top"
  [closable]="true" [(visible)]="show"
>
  <ng-template pTemplate="header">{{ 'profiles.view.referral-report.add-referral' | translate | titlecase }}</ng-template>
  <form #crudForm="ngForm" class="atlas-form">
    <div class="mct-flex mct-col mct-gap-27"  >
      <div>
        <label for="referralType">{{'profiles.view.referral-report.referral-type' | translate | titlecase}}</label>
        <p-select
          [placeholder]="'common.select' | translate | titlecase"
          [(ngModel)]="referralSummary.ReferralType"
          name="referralType"
          [options]="referralTypes"
          optionValue="ReferralType"
          optionLabel="ReferralType"
          appendTo="body"
          styleClass="w-100"
          required
          ngDefaultControl
        ></p-select>
      </div>
      <div>
        <div>{{'profiles.view.referral-report.referral-date' | translate | titlecase}}</div>
        <wl-date-selector ngDefaultControl name="referralDate" [(ngModel)]="referralSummary.ReferralDate"></wl-date-selector>
      </div>
      <div>
        <label for="referralCount">{{'profiles.view.referral-report.number-of-referrals' | translate | titlecase}}</label>
        <input name="referralCount" [(ngModel)]="referralSummary.ReferralCount" type="number" min="1" required />
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!crudForm.valid" (click)="addReferral()">
      {{ 'common.add' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
